import { version } from '../../package.json';

/** Package metadata is the single source of the SDK's diagnostic version. */
export const SDK_VERSION = version;

/** True for the semver shape the diagnostics endpoint accepts. */
export function isSemverLike(value: unknown): value is string {
  return typeof value === 'string' && /^[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z.-]+)?$/.test(value);
}

/**
 * The version string to report. Invalid package metadata is rejected rather
 * than forwarded: the field is part of a strict
 * allowlist, and an out-of-contract value would fail the whole batch.
 */
export function reportedSdkVersion(): string {
  return isSemverLike(SDK_VERSION) ? SDK_VERSION : '0.0.0';
}
